<template>
  <div class="rt-navbar">
    <div class="rt-navbar-layout">
      <!-- 顶部导航左侧插槽 -->
      <div
        v-if="$slots['left']"
        class="rt-navbar-left"
      >
        <slot name="left"></slot>
      </div>
      <!-- 顶部导航中间插槽 -->
      <div
        v-if="$slots['center']"
        class="rt-navbar-center"
      >
        <slot name="center"></slot>
      </div>
      <!-- 顶部导航右侧插槽 -->
      <div
        v-if="$slots['right']"
        class="rt-navbar-right"
      >
        <slot name="right"></slot>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'RtNavbar',
  props: {},
  data () {
    return {};
  },
  computed: {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// rtNavbar.vue?79acf02e